// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"487bbd94","453":"36178609","486":"44fbfc9c","614":"b1176cbe","679":"8aca5ce3","968":"8faeb680"}[chunkId] + ".chunk.js";
};